module.exports = __webpack_public_path__ + "img/csm_Geschichte_Einst-und-heute_04_cef93fdd82.68555c54.jpg";